<template>
  <component :is="tag" class="newbtn">
    <slot />
  </component>
</template>

<script>
  export default {
    props: {
      tag: {type: String, default: 'button'}
    }
  }
</script>

<style lang="sass" scoped>
.newbtn
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center
  text-align: center
  font-weight: 500
  font-size: 18px
  line-height: 1.16
  background: colors.$newred
  padding: 1px 40px 0
  color: colors.$notred
  position: relative
  border-radius: 8px
  height: 56px
  font-family: globalvars.$font6
  letter-spacing: globalvars.$onespacing
  min-width: 180px
  transition: .2s ease-out
  &:hover, &:active
    background: colors.$newRedHover
  &::before
    content: ''
    position: absolute
    border-radius: 8px
    left: 0
    top: 0
    right: 0
    box-shadow: none !important
    bottom: 0
    opacity: .16
    transition: .2s ease-out
  &[disabled]
    pointer-events: none
    &,&:hover, &:active
      background: colors.$moar_silver_for_the_god_of_silver2
    &::before
      background: rgba(0,0,0,0)

  &_sm
    font-size: 14px
    height: 47px
    padding: 1px 16px 0
  &_gray2
    position: relative
    background: #9f9f9f
    span
      position: relative
      z-index: 1
    &:hover
      background: darken(#9f9f9f,5)
    &:active
      background: darken(#9f9f9f,10)
  &_gray
    position: relative
    span
      position: relative
      z-index: 1
    &,&:hover, &:active
      background: colors.$moar_silver_for_the_god_of_silver2
    &::before
      background: rgba(0,0,0,0)
    &:hover, &:active
      &::before
        background: rgba(0,0,0,0.5)

</style>